// Section 22 Health tab (stream M3b), the tab root: reads the store's signals, builds the view
// model and dispatches the health actions. Sick and injured list with treatment (last season and
// planned), death risk with its factors and the player's marks; the health-care policy; healers,
// capacity and medicine; the quarantine; the illness multiplier with its levers; last season's
// illness and recovery lines. Every other component in this folder takes props. Edits are
// allowed only while deciding.
import { useComputed } from '@preact/signals';
import {
  draft,
  game,
  runConfig,
  setHealthCarePolicy,
  setTriageOverride,
  status,
} from '../../store';
import { healthVM } from '../../viewModels/health';
import { jobLabel } from '../../viewModels/people';
import { fill, healthText } from '../text/en';
import { CarePanel } from './care-panel';
import { MultiplierPanel } from './multiplier-panel';
import { PatientsTable } from './patients-table';
import './health.css';

function RecentList({ lines }: { lines: readonly string[] }) {
  return (
    <section class="health__section health__recent" aria-labelledby="health-recent">
      <h3 id="health-recent">{healthText.recent}</h3>
      {lines.length === 0 ? (
        <p class="hint">{healthText.noRecent}</p>
      ) : (
        <ul class="health__lines">
          {lines.map((line, i) => (
            <li key={i}>{line}</li>
          ))}
        </ul>
      )}
    </section>
  );
}

export function HealthTab() {
  const vm = useComputed(() =>
    game.value === null
      ? null
      : healthVM(game.value, draft.value, status.value === 'deciding', runConfig()),
  );
  const v = vm.value;
  if (v === null) return null;
  return (
    <div class="health" aria-label={healthText.title}>
      <p class="health__intro">{healthText.intro}</p>
      {!v.canEdit && <p class="hint">{healthText.readOnly}</p>}
      <PatientsTable
        rows={v.patients}
        manual={v.manual}
        canEdit={v.canEdit}
        jobLabel={jobLabel}
        onMark={(id, mark) => setTriageOverride(id, mark)}
      />
      <div class="health__columns">
        <CarePanel vm={v} onPolicy={(option) => setHealthCarePolicy(option)} />
        <MultiplierPanel multiplier={v.multiplier} levers={v.levers} />
      </div>
      <RecentList lines={v.recent.map((n) => fill(n, jobLabel))} />
    </div>
  );
}
